export function isObject(v: unknown): v is object {
  return Object(v) === v
}
